import React from 'react';
import PropTypes from 'prop-types';
import PartnerCard from '../partner-card';
import PartnerLogo from '../partner-logo';
import { partnersData } from './constants';

import './style.css';

const PartnersList = ({ onlyLogos }) => {
  if (onlyLogos) {
    return (
      <ul className="c-partners-logo-list">
        {partnersData.map(partnerData => (
          <li key={partnerData.id}>
            <PartnerLogo partner={partnerData} />
          </li>
        ))}
      </ul>
    );
  }

  return (
    <div className="c-partners-list">
      <div className="container">
        <div className="row">
          <div className="col">
            <p className="intro">The organisations which are members of AirQast are:</p>
          </div>
        </div>
        <div className="row">
          {partnersData.map(partnerData => (
            <div key={partnerData.id} className="col-sm col-md-6 col-lg-4 align-self-stretch">
              <div className="item">
                <PartnerCard partner={partnerData} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

PartnersList.propTypes = {
  onlyLogos: PropTypes.bool
};

PartnersList.defaultProps = {
  onlyLogos: false
};

export default PartnersList;



// WEBPACK FOOTER //
// ./src/components/partners-list/index.js